import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import WhatIsSection from './components/WhatIsSection';
import CategoryGrid from './components/CategoryGrid';
import ArticlePreview from './components/ArticlePreview';
import TrustSection from './components/TrustSection';

export default function Home() {
  return (
    <>
      <JsonLd
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Sugargoo Spreadsheet - Ultimate Product Database & Shopping Guide',
          description: 'Discover the most comprehensive Sugargoo Spreadsheet database with organized product finds, shopping guides, shipping tips, warehouse info, and exclusive resources.',
          url: 'https://sugargoosheet.help/',
          about: {
            '@type': 'Thing',
            name: 'Sugargoo Spreadsheet',
            description: 'A curated database of product finds and shopping resources for the Sugargoo platform',
          },
          publisher: {
            '@type': 'Organization',
            name: 'Sugargoo Sheet Help',
            url: 'https://sugargoosheet.help/',
          },
        }}
      />
      <JsonLd
        schema={{
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Sugargoo Sheet Help',
          url: 'https://sugargoosheet.help/',
          description: 'The independent resource for Sugargoo Spreadsheet discovery. Find better products faster with our organized database, shopping guides, shipping tips, and exclusive resources.',
          sameAs: ['https://kaspreadsheet.com'],
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <WhatIsSection />
          <CategoryGrid />
          <ArticlePreview />
          <TrustSection />
        </main>
        <Footer />
      </div>
    </>
  );
}